import { NavItem } from "../interfaces/Nav.interface";

export const navItems: NavItem[] = [
  {
    id: "home",
    label: "Home",
    icon: "mdi:home-outline",
    href: "/",
  },
  {
    id: "reels",
    label: "Reels",
    icon: "mdi:movie-play-outline",
    href: "/community/reels",
  },
  {
    id: "marketplace",
    label: "Marketplace",
    icon: "mdi:storefront-outline",
    href: "/community/marketplace",
  },
  {
    id: "groups",
    label: "Groups",
    icon: "mdi:account-group-outline",
    href: "/community/groups",
  },
  {
    id: "friends",
    label: "Friends",
    icon: "mdi:users",
    href: "/community/friends",
  },
  { id:"jobs",label: "Jobs", href: "/community/jobs", icon: "mdi:briefcase" },
  // { id:"chat",label: "Chat", href: "/messenger", icon: "mdi:message" },

];